module.exports = __webpack_public_path__ + "img/watchman.1a2f3e94.png";